import api from '../../services/api';

export function normalizeText(value) {
  if (typeof value !== 'string') return value || '';
  return value.trim();
}

export function getItinerarySideLabel(side) {
  if (side === 'bride') return 'Bride side';
  if (side === 'groom') return 'Groom side';
  return 'Both sides';
}

export function getItineraryOptionLabel(item) {
  const date = item?.date ? new Date(item.date) : null;
  const dateLabel = date && !Number.isNaN(date.getTime())
    ? date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
    : 'Date not set';
  return [item?.name || 'Unnamed event', dateLabel, getItinerarySideLabel(item?.side)].join(' | ');
}

export function getSelectedItineraryIds(vendor) {
  if (Array.isArray(vendor?.itinerary_item_ids)) {
    return Array.from(new Set(vendor.itinerary_item_ids.filter(Boolean)));
  }
  return vendor?.itinerary_item_id ? [vendor.itinerary_item_id] : [];
}

export function buildVendorPayload(vendor) {
  const category = vendor.category === 'other'
    ? normalizeText(vendor.custom_category)
    : vendor.category;

  return {
    master_vendor_id: normalizeText(vendor.master_vendor_id) || null,
    itinerary_item_id: normalizeText(vendor.itinerary_item_id) || null,
    name: normalizeText(vendor.name),
    category,
    city: normalizeText(vendor.city) || null,
    contact_name: normalizeText(vendor.contact_name) || null,
    phone: normalizeText(vendor.phone) || null,
    email: normalizeText(vendor.email) || null,
    cost_level: normalizeText(vendor.cost_level) || null,
    quality_level: normalizeText(vendor.quality_level) || null,
    notes: normalizeText(vendor.notes) || null,
  };
}

export async function createVendorAssignments(eventId, vendor, itineraryItemIds, masterVendorId = null) {
  const basePayload = buildVendorPayload(vendor);
  let resolvedMasterVendorId = masterVendorId || basePayload.master_vendor_id;
  const createdVendors = [];

  for (const itineraryItemId of itineraryItemIds) {
    const response = await api.post(`/events/${eventId}/vendors`, {
      ...basePayload,
      master_vendor_id: resolvedMasterVendorId || null,
      itinerary_item_id: itineraryItemId,
    });
    createdVendors.push(response.data);
    resolvedMasterVendorId = response.data?.master_vendor_id || resolvedMasterVendorId;
  }

  return createdVendors;
}
